module.exports = __webpack_public_path__ + "static/media/yy5.e02119ce.png";